import React, { useEffect, useState } from 'react';
import calendarIcon from '../../../../../../../Assets/images/calender.svg';
import apiClient from '../../../../../../../Config/apiClient';
import { showSuccessToast, showErrorToast } from '../../../../../../../Context/Toaster/Toaster';
import "./InvoiceDetailsTab.scss";
import Loader from '../../../../../../../Context/Loader/Loader';
import { hasPermission } from '../../../../Services/permission';
import moment from 'moment';
import { DATE_FORMAT } from '../../../../Utils/Constants';

const invoicePath = process.env.REACT_APP_CC_INVOICES_BASE_PATH;

const INVOICE_SECTION = "Invoices";
const INVOICE_UPDATE_KEY = ["invoices_update"];

const InvoiceDetailsTab = ({ invoice, refreshInvoice, refreshInvoices }) => {
    const [paidRef, setPaidRef] = useState('');
    const [paidDate, setPaidDate] = useState('');
    const [errors, setErrors] = useState({ paidRef: '', paidDate: '' });
    const [loading, setLoading] = useState(false);

    const [isPaidState, setIsPaidState] = useState(invoice?.paid_status === 1);
    const [localPaidRef, setLocalPaidRef] = useState(invoice?.paid_ref_no || '');
    const [localPaidDate, setLocalPaidDate] = useState(invoice?.paid_datetime?.slice(0, 10) || '');
    const canUpdatePayment = hasPermission({ section: INVOICE_SECTION, keys: INVOICE_UPDATE_KEY });

    useEffect(() => {
        if (invoice) {
            setIsPaidState(invoice.paid_status === 1);
            setLocalPaidRef(invoice.paid_ref_no || '');
            setLocalPaidDate(invoice.paid_datetime?.slice(0, 10) || '');
        }
    }, [invoice]);

    if (!invoice) {
        return <div className="text-center py-5 text-muted">No data found</div>;
    }

    const handleUpdate = async () => {
        const newErrors = {
            paidRef: !paidRef.trim() ? 'Comment is required' : '',
            paidDate: !paidDate ? 'Paid date is required' : '',
        };
        setErrors(newErrors);

        if (newErrors.paidRef || newErrors.paidDate) {
            return;
        }

        setLoading(true);

        try {
            const body = {
                invoice_id: invoice.id,
                paid_status: 1,
                paid_datetime: paidDate,
                paid_ref_no: paidRef,
            };

            const res = await apiClient.put(`${invoicePath}/update-payment`, body);

            if (res.data.status === 'SUCCESS') {
                showSuccessToast('Invoice marked as paid');
                if (typeof refreshInvoice === 'function') {
                    await refreshInvoice();
                    await refreshInvoices();
                }
            } else {
                showErrorToast(res.data.message || 'Failed to update');
            }
        } catch (err) {
            console.error(err);
            showErrorToast('Something went wrong while updating invoice');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="tab-pane fade show active" id="viewjob-tab-pane1" role="tabpanel" tabIndex={0}>
            <div className="vr-inner">
                <div className="vr-top-invoice">
                    <div className="vrt-left">
                        <h3>Invoice Id</h3>
                        <p>{invoice.inv_no || '--'}</p>
                    </div>
                </div>

                <div className="vrt-content">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Invoice Date</h3>
                                <p>{moment.utc(invoice.inv_datetime).local().format(DATE_FORMAT)}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Date Range</h3>
                                <p>{moment(invoice.inv_start_date_only, "YYYY-MM-DD").format(DATE_FORMAT)} - {moment(invoice.inv_end_date_only, "YYYY-MM-DD").format(DATE_FORMAT)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>No Of Jobs</h3>
                                <p>{invoice.jobs_count}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Due Date</h3>
                                <p>{moment.utc(invoice.inv_due_date).local().format(DATE_FORMAT)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Invoice Amount</h3>
                                <p>${Number(invoice.inv_amount).toFixed(2)}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Paid Status</h3>
                                <p>{isPaidState ? 'Paid' : 'Pending'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="vrt-split inv-padding" style={{ position: 'relative' }}>
                                <h3 className="mb-3">Payment Details</h3>
                                <h3>Comments <span style={{ color: 'red' }}>*</span></h3>
                                <textarea className={`common-text mt-2 ${errors.paidRef ? 'error' : ''}`} maxLength={200} value={isPaidState ? localPaidRef : paidRef}
                                    onChange={(e) => {
                                        setPaidRef(e.target.value);
                                        if (errors.paidRef && e.target.value.trim()) {
                                            setErrors((prev) => ({ ...prev, paidRef: '' }));
                                        }
                                    }}
                                    disabled={isPaidState || !canUpdatePayment}
                                />
                                <span className={`error-text ${errors.paidRef ? 'active' : ''}`}>
                                    {errors.paidRef || ' '}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding" style={{ position: 'relative' }}>
                                <h3>Paid Date</h3>
                                <div className="invoicedate-split">
                                    <input
                                        className={`custom-datetime-input common-input id-picker ${errors.paidDate ? 'error' : ''}`}
                                        type="date"
                                        value={isPaidState ? localPaidDate : paidDate}
                                        onChange={(e) => {
                                            setPaidDate(e.target.value);
                                            if (errors.paidDate && e.target.value) {
                                                setErrors((prev) => ({ ...prev, paidDate: '' }));
                                            }
                                        }}
                                        disabled={isPaidState || !canUpdatePayment}
                                    />
                                    <img className="calendar-icon ic-icon" src={calendarIcon} alt="calendar" />
                                </div>
                                <span className={`error-text ${errors.paidDate ? 'active' : ''}`}>
                                    {errors.paidDate || ' '}
                                </span>
                            </div>
                        </div>

                        {!isPaidState && canUpdatePayment && (
                            <div className="col-md-6">
                                <div className="vrt-split inv-padding">
                                    <button className="cp-button save-btn float-start invoice-update" onClick={handleUpdate} disabled={loading}>
                                        {loading ? <Loader /> : "Update"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDetailsTab;
